import { IBudgetProgramFilterRequest } from '../../../../model/sge/budget-program/request/budget-program-filter-request';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';

export type BudgetProgramSearchState = {
    parameters: IBudgetProgramFilterRequest;
    budgetUnits: IBudgetUnitResponse[];
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    setBudgetUnits = 'setBudgetUnits',
    triggerSearch = 'triggerSearch',
}

export const BudgetProgramSearchReducer = (state: BudgetProgramSearchState, action: any): BudgetProgramSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.setBudgetUnits:
            return { ...state, budgetUnits: payload };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
